<template>
<v-card flat outlined class="ma-4">
  <v-toolbar flat color="primary white--text">
    <v-toolbar-title>Update Data Masjid</v-toolbar-title>
  </v-toolbar>
  <v-card-text>
    <form v-on:keyup.enter="submitUpdate">
      <v-row no-gutters class="mt-4">
        <v-col>
          <v-text-field
            outlined
            v-model.trim="$v.masjidForm.name.$model"
            label="Nama Masjid"
            :error-messages="nameError"
          ></v-text-field>
        </v-col>
        <v-col class="ml-3">
          <v-text-field
            outlined
            v-model.trim="$v.masjidForm.address.$model"
            :error-messages="addressError"
            label="Alamat Masjid"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row no-gutters class="mt-0">
        <v-col>
           <v-text-field
            outlined
            v-model.trim="$v.masjidForm.city.$model"
            :error-messages="cityError"
            label="Kota"
          ></v-text-field>
        </v-col>
        <v-col class="ml-3">
          <v-text-field
            outlined
            v-model.trim="$v.masjidForm.province.$model"
            :error-messages="provinceError"
            label="Provinsi"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row no-gutters class="mt-0">
        <v-col>
          <v-text-field
            outlined
            v-model="masjidForm.latitude"
            label="Latitude"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col class="ml-3">
          <v-text-field
            outlined
            v-model="masjidForm.longitude"
            label="Longitude"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row no-gutters class="mt-0">
        <v-col>
          <v-text-field
            outlined
            v-model.trim="$v.masjidForm.year_built.$model"
            :error-messages="yearError"
            label="Tahun Berdiri"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col class="ml-3">
          <v-text-field
            outlined
            v-model="masjidForm.additional_info"
            label="Info Tambahan"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-textarea
        outlined
        label="Sejarah"
      ></v-textarea>
      <v-file-input
        v-model="file"
        accept="image/*"
        label="Foto Masjid"
        filled
        prepend-icon="mdi-camera"
      ></v-file-input>
      <v-btn @click="submitUpdate" color="primary">Update</v-btn>
      <p v-if="isFormError" class="mt-2 red--text text-caption error-caption">
        "Manusia memang sering melakukan kesalahan, tapi yang terpenting adalah
        bagaimana kita memperbaikinya" <br />
        -Admin
      </p>

      <p v-if="isUpdateError" class="mt-2 red--text text-caption error-caption">
        Maaf, terjadi kesalahan saat update data, mohon ulangi update
        kembali. ^^
      </p>
    </form>
  </v-card-text>
</v-card>
</template>

<style scoped>
.error-caption {
  width: 350px;
}
</style>

<script>
import router from "../router";
import { required, minLength, maxValue } from "vuelidate/lib/validators";
const year = new Date().toISOString().substr(0, 4)

export default {
  data() {
    return {
      masjidDetail: {},
      masjidForm: {
        name: "",
        address: "",
        city: "",
        province: "",
        latitude: 0,
        longitude: 0,
        year_built: 0,
        additional_info: ""
      },
      file: null,
      isFormError: false,
      isUpdateError: false,
    };
  },
  validations: {
    masjidForm: {
      name: {
        required,
        minLength: minLength(3)
      },
      address: {
        required,
        minLength: minLength(5)
      },
      city: {
        required,
        minLength: minLength(4)
      },
      province: {
        required,
        minLength: minLength(4)
      },
      year_built: {
        required,
        maxYear: maxValue(year)
      }
    }
  },
  computed: {
    masjidDetails () {
      return this.masjidDetail
    },
    nameError() {
      const errors = [];
      if (!this.$v.masjidForm.name.$dirty) return errors;
      !this.$v.masjidForm.name.minLength &&
        errors.push("Nama Masjid minimal 3 huruf");
      !this.$v.masjidForm.name.required &&
        errors.push("Nama Masjid tidak boleh kosong");
      return errors;
    },
    addressError() {
      const errors = [];
      if (!this.$v.masjidForm.address.$dirty) return errors;
      !this.$v.masjidForm.address.minLength &&
        errors.push("Alamat Masjid minimal 5 huruf");
      !this.$v.masjidForm.address.required &&
        errors.push("Alamat Masjid tidak boleh kosong");
      return errors;
    },
    cityError() {
      const errors = [];
      if (!this.$v.masjidForm.city.$dirty) return errors;
      !this.$v.masjidForm.city.minLength &&
        errors.push("Nama Kota minimal 4 huruf");
      !this.$v.masjidForm.city.required &&
        errors.push("Nama Kota tidak boleh kosong");
      return errors;
    },
    provinceError() {
      const errors = [];
      if (!this.$v.masjidForm.province.$dirty) return errors;
      !this.$v.masjidForm.province.minLength &&
        errors.push("Nama Provinsi minimal 4 huruf");
      !this.$v.masjidForm.province.required &&
        errors.push("Nama Provinsi tidak boleh kosong");
      return errors;
    },
    yearError() {
      const errors = [];
      if (!this.$v.masjidForm.year_built.$dirty) return errors;
      !this.$v.masjidForm.year_built.required &&
        errors.push("Tahun Berdiri tidak boleh kosong");
      !this.$v.masjidForm.year_built.maxYear &&
        errors.push("Tahun Berdiri tidak bisa melebihi tahun ini");
      return errors;
    },
  },
  created() {
    var masjidId = localStorage.getItem("masjid");
    this.axios("masjid/detail/" + masjidId)
      .then((response) => {
        if (response.data.data !== null) {
          this.masjidDetail = response.data.data;
          // console.log(response, 'res fetch masjid')
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  watch: {
    masjidDetails () {
      this.masjidForm.name = this.masjidDetails.name
      this.masjidForm.address = this.masjidDetails.address
      this.masjidForm.city = this.masjidDetails.city
      this.masjidForm.province = this.masjidDetails.province
      this.masjidForm.latitude = this.masjidDetails.latitude
      this.masjidForm.longitude = this.masjidDetails.longitude
      this.masjidForm.year_built = this.masjidDetails.year_built
      this.masjidForm.additional_info = this.masjidDetails.additional_info
    }
  },
  methods: {
    submitUpdate: async function () {
      var masjidId = localStorage.getItem("masjid")
      var token = this.$store.getters.getToken
      this.isUpdateError = false;
      this.$v.$touch()
      if (this.$v.masjidForm.$invalid) {
        this.isFormError = true
      }else{
        this.isFormError = false
        //add new masjid
        await this.axios({
          method: 'post',
          url: `/masjid/update/${masjidId}`,
          data: this.masjidForm,
          headers: {token}
        })
        .then((response) => {
          console.log(response, 'res update masjid')
        })
        .catch((error) => {
            console.log(error, 'error update masjid')
            this.isUpdateError = true
        })

        // console.log(this.file)
        if(this.file !== null) {
          let formData = new FormData();
          formData.append("file", this.file);
          // console.log(formData)
          //add file images
          this.axios.post(
          `/masjid/image/${masjidId}`,
          formData, 
          {headers: {"Content-Type": "multipart/form-data"}}
          )
          .then((response) => {
            console.log(response, 'res update masjid images')
            // router.push("/admin/profile");
          })
          .catch((error) => {
            console.log(error, 'error update masjid images')
            this.isUpdateError = true
          })
        }
        
        if(this.isUpdateError === false) router.push("/admin/profile");
      }
    },
  },
};
</script>